module.exports = __webpack_public_path__ + "static/img/pay-help1.b902f554.png";